import React from 'react';
import { Table } from 'semantic-ui-react';
import selectors from '../hooks/selectors';
import DatasetSettingsTable from '../../settings/components/DatasetSettingsTable';
import RequestMetricsTableHeader from './RequestMetricsTableHeader';
import DatasetSettingsTableLoader from '../../settings/components/DatasetSettingsTableLoader';
import DatasetMetricsHeaderRow from './DatasetMetricsHeaderRow';
import DatasetMetricsRow from './DatasetMetricsRow';

const DatasetMetricsTable = ({ category, code }) => {
  const { metrics, isLoading } = selectors.useDatasetMetricsTable({ category, code });

  return (
    <>
      {(isLoading) && (<DatasetSettingsTableLoader />)}
      {(!isLoading) && (
      <DatasetSettingsTable className="aridhia-dataset-metrics-table">
        <Table.Header>
          <RequestMetricsTableHeader numberOfColumns={4} />
          <DatasetMetricsHeaderRow />
        </Table.Header>
        <Table.Body>
          <DatasetMetricsRow
            total={metrics?.total || 0}
            totalApproved={(metrics?.total_approved || 0) + (metrics?.total_approved_waiting || 0)}
            totalDenied={(metrics?.total_denied || 0) + (metrics?.total_denied_waiting || 0)}
            totalTransfers={metrics?.total_transfers || 0}
          />
        </Table.Body>
      </DatasetSettingsTable>
      )}
    </>
  );
};

export default DatasetMetricsTable;
